import configs from 'react-native-config';

import { useCompanyAdjustTracking } from '@webtrader/core/services/company';

import { checkIsAndroid } from '@/utils/device';

export const useAdjustTrackingEnabled = () => {
  const adjustEnabled = useCompanyAdjustTracking();

  const isAdjustIosEnabled = adjustEnabled && configs.ADJUST_APP_TOKEN_IOS && configs.ADJUST_APP_TOKEN_IOS.length > 0;
  const isAdjustAndroidsEnabled =
    adjustEnabled && configs.ADJUST_APP_TOKEN_ANDROID && configs.ADJUST_APP_TOKEN_ANDROID.length > 0;

  const adjustTrackingEnabled = checkIsAndroid() ? isAdjustAndroidsEnabled : isAdjustIosEnabled;

  return adjustTrackingEnabled;
};
